import { makeAutoObservable } from "mobx";

export class UnaiLocalStore {
  instanceId: string;
  props: any = {};

  constructor(instanceId: string) {
    this.instanceId = instanceId;
    makeAutoObservable(this);
  }

  setProps(props: any) {
    this.props = props;
  }
}

export default UnaiLocalStore;
